import styled from 'styled-components';

export const ModalHeader = styled.div`
  text-align: justify;
  margin: 16px 0;
`;

export const ModalContent = styled.div`
  text-align: justify;
  margin: 16px 0;
`;
